import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactDOM from "react-dom";
import { Helmet } from "react-helmet";
import { css } from "twin.macro";

interface ScheduleMeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ScheduleMeetingModal: React.FunctionComponent<
  ScheduleMeetingModalProps
> = ({ isOpen, onClose }) =>
  isOpen
    ? ReactDOM.createPortal(
        <>
          <Helmet>
            <script
              type="text/javascript"
              src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
            ></script>
          </Helmet>
          <div
            css={css`
              position: fixed;
              z-index: 100;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              overflow: auto;
              &::before {
                content: "";
                position: fixed;
                background-color: #000;
                width: 100%;
                height: 100%;
                z-index: -1;
                opacity: 0.8;
              }
            `}
          >
            <div
              css={css`
                position: fixed;
                top: 20px;
                right: 20px;
              `}
            >
              <button
                css={css`
                  background-color: transparent;
                  border: none;
                  cursor: pointer;
                `}
                onClick={onClose}
              >
                <FontAwesomeIcon
                  icon={faTimes}
                  color="#fff"
                  transform="grow-4"
                />
              </button>
            </div>
            <div
              className="meetings-iframe-container"
              data-src="https://meetings.hubspot.com/tony-sternberg/web-demo?embed=true"
              css={css`
                margin-top: 30px;
              `}
            ></div>
          </div>
        </>,
        document.body
      )
    : null;

export default ScheduleMeetingModal;
